import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import RefundReport from './components/RefundReport/Index.vue'
import FeedbackReport from './components/FeedbackReport/Index.vue'
import availableEventCategories from "../../../../helpers/availableEventCategoriesHelper";

export default {
  name: 'EventDetails',
  components: {
    FeedbackReport,
    RefundReport
  },
  computed,
  data,
  methods,
  mounted
}
